import { getCookie, setCookie } from './cookies';
import getQueryStringParams from './QueryString';
import CONSTS from '../Consts/Consts';
import { langsAllowed } from './../Lang/lng';

export default function redirectIfRegistred() {
    const queryString = getQueryStringParams(location.search);
    const registered = getCookie('registered')
    if (registered == '1' && window.redirectToIml != 1 && !queryString.debug) {
        const wid = getCookie('wid');
        const widToSend = (wid != '' && (!isNaN(wid) || !isNaN(parseInt(wid)))) ? wid : '126612974175';
        const promocode = queryString['promocode'] || 'noPromocode';
        let url = CONSTS.imliveWmaster;
        const lang = queryString.c && queryString.c != 'en-EN' && langsAllowed.indexOf(queryString.c) > -1 ? queryString.c : '';
        let linkid = 1319;

        if (queryString.wl) {
            linkid = 1318;
            url = `https://${queryString.wl}${CONSTS.directLinkHandler}`;
        } else if (queryString.c && lang) {
            url = `${CONSTS.langImlive}${CONSTS.directLinkHandler}`;
        }

        url = `${url}?WID=${widToSend}&linkid=${linkid}&promocode=${promocode}${lang ? `&c=${lang}` : ''}`;

        window.location.href = url;
    }

    if (getCookie('registered') != '1') {
        setCookie('wid', queryString['wid'] || '', 1500);
    }
}